var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirculationPumpOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 223,
    viewBox: "0 0 149 223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 88.75,
    height: 5.19,
    transform: "translate(60.25 195.77)",
    fill: "#6a7084"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M9.96,142.35a2.593,2.593,0,0,1-2.59-2.6V10.59A10.6,10.6,0,0,1,17.94,0H138.18a2.6,2.6,0,0,1,0,5.2H17.94a5.4,5.4,0,0,0-5.39,5.4V139.77A2.588,2.588,0,0,1,9.96,142.35Z",
    fill: "#6a7084"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M22.04,142.35a2.593,2.593,0,0,1-2.59-2.6v-6.72a10.59,10.59,0,0,1,10.57-10.59H138.18a2.6,2.6,0,0,1,0,5.2H30.03a5.4,5.4,0,0,0-5.39,5.4v6.72A2.606,2.606,0,0,1,22.04,142.35Z",
    fill: "#6a7084"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9826",
    "data-name": "Group 9826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M33.23,167.4a27.627,27.627,0,0,0-6.78.87v-4.62h1.91a3.5,3.5,0,0,0,3.5-3.5V156.2H.13v3.95a3.5,3.5,0,0,0,3.5,3.5H5.54v31.48A27.68,27.68,0,1,0,33.23,167.4Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M33.23,223A27.875,27.875,0,0,1,5.41,195.13V163.78H3.63A3.638,3.638,0,0,1,0,160.14v-4.08H32v4.08a3.638,3.638,0,0,1-3.63,3.64H26.59v4.32A27.848,27.848,0,1,1,33.23,223ZM.27,156.34v3.81a3.369,3.369,0,0,0,3.36,3.37H5.68v31.62a27.55,27.55,0,1,0,27.55-27.6,27.286,27.286,0,0,0-6.74.87l-.17.04v-4.93h2.05a3.363,3.363,0,0,0,3.36-3.37v-3.81H.27Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M28.37,147.26H26.46v-7.51H5.55v7.51H3.63a3.5,3.5,0,0,0-3.5,3.5v3.95H31.86v-3.95A3.489,3.489,0,0,0,28.37,147.26Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M32,154.85H0v-4.08a3.638,3.638,0,0,1,3.63-3.64H5.41v-7.51H26.58v7.51h1.78a3.638,3.638,0,0,1,3.63,3.64v4.08ZM.27,154.58H31.74v-3.81a3.369,3.369,0,0,0-3.36-3.37H26.33v-7.51H5.68v7.51H3.63a3.363,3.363,0,0,0-3.36,3.37v3.81Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9824",
    "data-name": "Group 9824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M33.38,206.78a11.9,11.9,0,0,1-10.16-6.72l1.02-.5a10.761,10.761,0,0,0,20.37-3.31l1.12.14A11.944,11.944,0,0,1,33.38,206.78Z",
    fill: "#8b90a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M33.93,207.12c-.19,0-.38,0-.56-.01h0a12.211,12.211,0,0,1-10.43-6.9l-.14-.29,1.6-.78.14.29a10.435,10.435,0,0,0,19.75-3.22l.04-.32,1.76.23-.04.32A12.281,12.281,0,0,1,33.93,207.12Zm-.53-.66a11.647,11.647,0,0,0,11.97-9.78l-.48-.06A11.084,11.084,0,0,1,24.1,200l-.44.21a11.589,11.589,0,0,0,9.74,6.25Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M47.92,199.77l-.73.44-2.18-3.58-3.41,2.45-.49-.69,4.14-2.98Z",
    fill: "#8b90a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M47.08,200.66l-2.17-3.56-3.38,2.43-.87-1.22,4.69-3.37,3.01,4.93Zm-1.98-4.49,2.2,3.6.17-.11-2.31-3.78-3.6,2.58.12.16Z",
    fill: "#8b90a0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M22.93,194.09,21.8,194a11.891,11.891,0,0,1,22.88-3.51l-1.05.43a10.759,10.759,0,0,0-20.7,3.17Z",
    fill: "#8b90a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M23.23,194.44l-1.77-.14.03-.32A12.217,12.217,0,0,1,45,190.38l.12.3-1.65.67-.12-.3a10.436,10.436,0,0,0-20.08,3.08Zm-1.07-.74.48.04a11.144,11.144,0,0,1,11.02-9.88,11.029,11.029,0,0,1,10.15,6.64l.45-.18a11.566,11.566,0,0,0-22.1,3.38Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M19.47,190.73l.7-.48,2.35,3.48,3.29-2.6.52.66-4,3.17Z",
    fill: "#8b90a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M22.26,195.43l-3.24-4.78,1.24-.84,2.34,3.45,3.27-2.59.93,1.18Zm-2.34-4.61,2.49,3.67,3.47-2.75-.13-.16-3.3,2.62-2.36-3.49Z",
    fill: "#8b90a0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M33.66,217.38a22.415,22.415,0,1,1,22.38-22.41A22.425,22.425,0,0,1,33.66,217.38Zm0-42.24a19.82,19.82,0,1,0,19.79,19.82A19.828,19.828,0,0,0,33.66,175.14Z",
    fill: "#8b90a0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculationPumpOff);
export default __webpack_public_path__ + "static/media/circulation_pump_off.e40346a05eb911251426eaba0848e93f.svg";
export { ForwardRef as ReactComponent };